import { TestimonyPublicationStatus } from '../../enums/publication-status.enums';
import { FiltersFormValue, QueryData } from '../query-data.payload';
import { AbstractTestimonyFormValue, AbstractTestimonyPayload } from './abstract-testimony.payload';

export interface TestimonyFormValue extends AbstractTestimonyFormValue {}

export class TestimonyPayload extends AbstractTestimonyPayload {
  constructor(formValue: Partial<TestimonyFormValue>) {
    super(formValue);
  }
}

export interface WTestimonyFiltersFormValue extends FiltersFormValue {
  publicationStatus?: TestimonyPublicationStatus;
}

export class WTestimonyQueryData extends QueryData {
  publicationStatus?: TestimonyPublicationStatus;

  constructor(filtersFormValue: WTestimonyFiltersFormValue) {
    super(filtersFormValue);
    this.publicationStatus = filtersFormValue.publicationStatus;
  }
}
